module.exports = "./img/830ca83ff107b7a0536e0ba72ad4da4a.jpg";